module.exports = __webpack_public_path__ + "media/images/avatar-default-eda314c82e3080f0df11e73f19c9adcd.png";